export function CommentsIcon({
  width,
  height,
  ...props
}: React.SVGProps<SVGSVGElement> & { fill?: string }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.33 9.00308C10.9376 7.95213 11.1417 6.71594 10.9044 5.52544C10.667 4.33494 10.0044 3.27157 9.04024 2.53397C8.0761 1.79637 6.8764 1.43501 5.66527 1.51738C4.45414 1.59976 3.31442 2.12024 2.45902 2.98159C1.60363 3.84294 1.09107 4.98624 1.0171 6.19792C0.943134 7.40959 1.31282 8.60675 2.05709 9.56576C2.80135 10.5248 3.8693 11.18 5.06142 11.4091C6.25354 11.6382 7.48828 11.4254 8.53499 10.8106L11.002 11.4991L10.33 9.00308Z"
        stroke="#3D352E"
        stroke-linejoin="round"
      />
    </svg>
  );
}
